import React, { useEffect, useState } from "react";
import styled from "styled-components";

const ProgressBar = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: ${({ theme }) =>
    `linear-gradient(to right, ${theme.primary}, ${theme.secondary})`};
  transform-origin: 0%;
  transform: scaleX(${(props) => props.progress});
  z-index: 1000;
  transition: transform 0.1s ease;
`;

const ScrollProgress = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const totalScroll =
        document.documentElement.scrollHeight - window.innerHeight;
      const currentProgress = window.scrollY / totalScroll;
      setProgress(currentProgress);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return <ProgressBar progress={progress} />;
};

export default ScrollProgress;
